import { faCopy } from '@fortawesome/pro-regular-svg-icons';
import { faCopy as faCopySolid } from '@fortawesome/pro-solid-svg-icons';
import { useMutation } from '@tanstack/react-query';
import { HoverIconButton } from 'components/button/HoverIconButton';
import { useNotificationContext } from 'contexts/NotificationContext';
import { tokens } from 'styles/tokens';
import { copyToClipboard } from 'utils/clipboard';

export type CopyButtonProps = Readonly<{
    text: string;
    title?: string;
}>;

export function CopyButton({ text, title = 'Copy to clipboard' }: CopyButtonProps) {
    const { showToast } = useNotificationContext();

    const { mutate: copy, isPending } = useMutation({
        mutationFn: () => copyToClipboard(text),

        onSuccess: () => {
            showToast({
                type: 'success',
                content: 'Successfully copied to clipboard',
            });
        },

        onError: () =>
            showToast({ type: 'error', content: 'Failed to copy to clipboard' }),
    });

    return (
        <HoverIconButton
            title={title}
            ariaLabel={title}
            icon={faCopy}
            hoverIcon={faCopySolid}
            color={tokens.icon.actionActive}
            hoverColor={tokens.icon.actionHover}
            disabled={isPending}
            onClick={() => copy()}
        />
    );
}
